import type React from "react"
import styled, { css } from "styled-components"
import {
  Checkbox as BaseCheckbox,
  type CheckboxProps as BaseCheckboxProps,
} from "~/ur-react-components"

interface StyledCheckboxProps {
  disabled?: boolean
  checked: boolean
}

const StyledCheckbox = styled(BaseCheckbox)<StyledCheckboxProps>`
  .--checkbox-box {
    border-color: ${(props) =>
      props.checked ? props.theme.colors.primary50 : props.theme.colors.gray60};
    background: ${(props) =>
      props.checked ? props.theme.colors.primary50 : "auto"};
    border-width: 2px;
  }

  &:focus {
    outline: none;

    .--checkbox-box {
      border-color: ${(props) => props.theme.colors.primary50};
    }
  }

  ${(props) =>
    props.disabled &&
    css`
      .--checkbox-box {
        background-color: ${(props) => props.theme.colors.gray70};
      }
    `};
`

interface CheckboxProps extends BaseCheckboxProps {}

export const CheckBox: React.FC<CheckboxProps> = ({ ...props }) => {
  return <StyledCheckbox {...props} />
}
